// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface SynchronizeTimeoutIconSignature {
  Element: SVGSVGElement;
}

export const SynchronizeTimeoutIcon: TOC<SynchronizeTimeoutIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M4.938 4.938C6.779 3.089 9.285 2 12 2C17.514 2 22 6.485 22 12C22 17.515 17.514 22 12 22V20C16.411 20 20 16.411 20 12C20 7.589 16.411 4 12 4C9.828 4 7.824 4.871 6.351 6.351L9 9H3V3L4.938 4.938ZM11 14V8H13V12H15V14H11Z"/>
</svg>
</template>;